import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  getBanks,
  getKpiCashFlow,
  getKpiCashFlowCompany,
} from "services/dashboard/dashboard-service";
import { notificationErroInternal } from "util/api-utils";
import { formatCurrency, formatCurrencyWithoutRS } from "util/format";
import FusionCharts from "fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.gammel";
import ReactFC from "react-fusioncharts";
import ReactFusioncharts from "react-fusioncharts";
import * as Widgets from "fusioncharts/fusioncharts.widgets.js";
import {
  mountChartIncome,
  mountChartLine,
  mountChartMultLine,
  mountChartPie,
  mountChartProfit,
  mountChartProfitBar,
  mountWaterFall,
} from "./func-chart-profit";
import { mountChartReceivedCompany } from "./func-chart-received-company";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  getCashFlow,
  getIncome,
  getStatus,
} from "services/client/client-service";
import { CSVLink } from "react-csv";
import { ColumnsCashFlowLate } from "./columns-table-kpi";
dayjs.extend(customParseFormat);
const dateFormat = "MM/YYYY";
ReactFC.fcRoot(FusionCharts, FusionTheme, Widgets);
FusionCharts.options["license"] = false;
const { info } = Modal;

const KpiCashFlow = () => {
  const [data, setData] = useState({
    sumByMonth: [],
    costKpi: [],
    cashFlowYear: [],
    costKpiAll: [],
  });
  const [filterStartDate, setStartDate] = useState(moment().format(dateFormat));
  const [loading, setLoading] = useState(false);
  const [filterEndDate, setEndDate] = useState(moment().format(dateFormat));
  const [banks, setBanks] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);
  const [status, setStatus] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [dataIncome, setDataIncome] = useState([]);
  const [loadingIncome, setLoadingIcome] = useState(false);
  const [dataCost, setDataCost] = useState([]);
  const [margin, setMargin] = useState(0);
  const [profit, setProfit] = useState(0);
  const [percentProfit, setPercentProfit] = useState(0);
  const [receiveValue, setReceiveValue] = useState(0);
  const [loadingKpi, setLoadingKpi] = useState(false);
  const [loadingCash, setLoadingCash] = useState(false);

  const [filterStartDateYear, setStartDateYear] = useState(
    moment(moment().year() + "-01").format(dateFormat)
  );
  const [filterEndDateYear, setEndDateYear] = useState(
    moment(moment().year() + "-12").format(dateFormat)
  );

  const [kpiReveueAndExpense, setKpiReveueAndExpense] = useState([]);
  const [kpiAmountFinal, setKpiAmountFinal] = useState([]);

  useEffect(() => {
    setLoading(true);

    getStatus().then((res) => {
      let selectStatus = res.map((obj) => ({
        value: obj.name,
        label: obj.name,
      }));
      let resIdStatus = res.map((item) => item.name);

      let resIdStatusCash = res
        .filter((f) => f.name != "Atrasado" && f.name != "Cancelado")
        .map((item) => item.name);

      setFilterStatus(resIdStatus);
      setStatus(selectStatus);
      getBanks().then((res) => {
        let selectBank = res.map((obj) => ({
          value: obj.codeAccount,
          label: obj.description,
        }));

        let resIdBank = res.map((item) => item.codeAccount);
        resIdBank.push("WITHOUT_BANK");

        let resIdBankCash = res
          .filter((item) => item.sumAmount == true)
          .map((item) => item.codeAccount);
        resIdBank.push("WITHOUT_BANK");

        setFilterBanks(resIdBank);
        setBanks(selectBank);

        getMappingDataIncome(resIdStatus, resIdBank);
        getMappingDataIncomeYear(resIdStatus, resIdBank);
        getMappingDataCash(resIdStatusCash, resIdBankCash);
      });
    });

    getMappingData();
  }, []);

  function getMappingDataCash(filterStatus, filterBanks) {
    setLoadingCash(true);
    const filter = {
      start: filterStartDateYear,
      end: filterEndDateYear,
      status: filterStatus,
      banks: filterBanks,
    };
    getCashFlow(filter)
      .then((res) => {
        const amountFinal = [];
        const cash = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "SALDO FINAL"
        );

        if (cash.length == 1) {
          cash[0].amountMonth.forEach((element) => {
            var name = element.month.substring(0, 3);
            name = name.replace("JAN", "Jan");
            name = name.replace("FEB", "Fev");
            name = name.replace("MAR", "Mar");
            name = name.replace("APR", "Abr");
            name = name.replace("MAY", "Mai");
            name = name.replace("JUN", "Jun");
            name = name.replace("JUL", "Jul");
            name = name.replace("AUG", "Ago");
            name = name.replace("SEP", "Set");
            name = name.replace("OCT", "Out");
            name = name.replace("NOV", "Nov");
            name = name.replace("DEC", "Dez");

            amountFinal.push({
              duaDateMonth: name,
              amount: element.profit,
            });
          });
        }
        setLoadingCash(false);
        setKpiAmountFinal(amountFinal);
      })
      .catch((err) => {
        setLoadingCash(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  function getMappingData() {
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
    };
    getKpiCashFlow(filter)
      .then((res) => {
        setData(res);
        let list = [];

        res.costKpi
          .filter((it) => it.isTotal == true)
          .forEach((item) => {
            list.push({ ...item, showChildren: false });
          });
        setDataCost(list);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncome(filterStatus, filterBanks) {
    setLoadingIcome(true);
    setLoading(true);

    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      status: filterStatus,
      banks: filterBanks,
    };
    getIncome(filter)
      .then((res) => {
        const dataIncome = res.mapping.filter((f) => f.mapping.length == 0);

        const receive = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "RECEITA LÍQUIDA"
        );
        const profit = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "RESULTADO OPERACIONAL"
        );
        const expeneses = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "DESPESAS OPERACIONAIS"
        );
        let total = 0;
        if (receive.length == 1) {
          total = receive[0].amountMonth.reduce((accumulator, object) => {
            return accumulator + object["profit"];
          }, 0);
        } else if (expeneses.length == 1) {
          total = expeneses[0].amountMonth.reduce((accumulator, object) => {
            return accumulator + object["profit"];
          }, 0);
        }
        dataIncome.forEach((element) => {
          element.amount = element.amountMonth.reduce((accumulator, object) => {
            return accumulator + object["profit"];
          }, 0);
          let percent = (element.amount * 100) / total;
          if (element.name.toUpperCase() == "MARGEM BRUTA") {
            setMargin(percent);
          }
          element.percent = formatCurrencyWithoutRS(percent.toFixed(2)) + "%";
        });

        if (profit.length == 1) {
          const profitValue = profit[0].amount;
          let receiveValue = 0;
          if (receive.length == 1 && receive[0].amountMonth.length == 1) {
            receiveValue = receive[0].amountMonth[0].receive;
          }
          if (profit[0].amountMonth.length == 1) {
            const profitValuePercent =
              profit[0].amountMonth[0].verticalAnalysis;
            setPercentProfit(profitValuePercent);
          }

          setReceiveValue(receiveValue);
          setProfit(profitValue);
        }
        setLoading(false);

        getMappingDataIncomeLastMonth(filterStatus, filterBanks, dataIncome);
      })
      .catch((err) => {
        setLoadingIcome(false);
        setLoading(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncomeYear(filterStatus, filterBanks) {
    setLoadingKpi(true);
    const filter = {
      start: filterStartDateYear,
      end: filterEndDateYear,
      status: filterStatus,
      banks: filterBanks,
    };
    getIncome(filter)
      .then((res) => {
        const kpiReveueAndExpense = [];
        const receive = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "RECEITA BRUTA"
        );
        const expeneses = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "DESPESAS OPERACIONAIS"
        );

        const tax = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "IMPOSTOS"
        );

        const custos = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "CUSTOS"
        );

        const profit = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "RESULTADO OPERACIONAL"
        );
        if (receive.length == 1) {
          receive[0].amountMonth.forEach((element) => {
            let expense = 0;
            if (expeneses.length == 1) {
              const monthExpense = expeneses[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpense.length == 1) {
                expense = expense + monthExpense[0].paid;
              }
            }
            if (tax.length == 1) {
              const monthExpenseTax = tax[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpenseTax.length == 1) {
                expense = expense + monthExpenseTax[0].paid;
              }
            }
            if (custos.length == 1) {
              const monthExpenseCustos = custos[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpenseCustos.length == 1) {
                expense = expense + monthExpenseCustos[0].paid;
              }
            }

            let profitValue = 0;
            if (profit.length == 1) {
              const monthProfit = profit[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthProfit.length == 1) {
                profitValue = profitValue + monthProfit[0].profit;
              }
            }

            var name = element.month.substring(0, 3);
            name = name.replace("JAN", "Jan");
            name = name.replace("FEB", "Fev");
            name = name.replace("MAR", "Mar");
            name = name.replace("APR", "Abr");
            name = name.replace("MAY", "Mai");
            name = name.replace("JUN", "Jun");
            name = name.replace("JUL", "Jul");
            name = name.replace("AUG", "Ago");
            name = name.replace("SEP", "Set");
            name = name.replace("OCT", "Out");
            name = name.replace("NOV", "Nov");
            name = name.replace("DEC", "Dez");

            kpiReveueAndExpense.push({
              month: name,
              revenue: element.receive,
              expense: parseFloat(expense.toFixed(2)),
              profit: profitValue,
            });
          });
        }
        const newKpi = [];

        if (expeneses.length == 1) {
          expeneses[0].amountMonth.forEach((element) => {
            let expense = 0;
            if (expeneses.length == 1) {
              const monthExpense = expeneses[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpense.length == 1) {
                expense = expense + monthExpense[0].paid;
              }
            }
            if (tax.length == 1) {
              const monthExpenseTax = tax[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpenseTax.length == 1) {
                expense = expense + monthExpenseTax[0].paid;
              }
            }
            if (custos.length == 1) {
              const monthExpenseCustos = custos[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthExpenseCustos.length == 1) {
                expense = expense + monthExpenseCustos[0].paid;
              }
            }

            let profitValue = 0;
            if (profit.length == 1) {
              const monthProfit = profit[0].amountMonth.filter(
                (i) => i.month == element.month
              );
              if (monthProfit.length == 1) {
                profitValue = profitValue + monthProfit[0].profit;
              }
            }

            var name = element.month.substring(0, 3);
            name = name.replace("JAN", "Jan");
            name = name.replace("FEB", "Fev");
            name = name.replace("MAR", "Mar");
            name = name.replace("APR", "Abr");
            name = name.replace("MAY", "Mai");
            name = name.replace("JUN", "Jun");
            name = name.replace("JUL", "Jul");
            name = name.replace("AUG", "Ago");
            name = name.replace("SEP", "Set");
            name = name.replace("OCT", "Out");
            name = name.replace("NOV", "Nov");
            name = name.replace("DEC", "Dez");

            const hasKPI = kpiReveueAndExpense.filter(
              (item) => item.month == name
            )[0];
            if (hasKPI) {
              newKpi.push({
                month: name,
                revenue: hasKPI.revenue,
                expense: parseFloat(expense.toFixed(2)),
                profit: profitValue,
              });
            } else {
              newKpi.push({
                month: name,
                revenue: element.receive,
                expense: parseFloat(expense.toFixed(2)),
                profit: profitValue,
              });
            }
          });
        } else {
          newKpi.push(...kpiReveueAndExpense);
        }
        setKpiReveueAndExpense(newKpi);
        setLoadingKpi(false);
      })
      .catch((err) => {
        setLoadingKpi(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function getMappingDataIncomeLastMonth(
    filterStatus,
    filterBanks,
    dataIncome
  ) {
    setLoadingIcome(true);
    let start = moment(
      filterStartDate.substring(3) + "-" + filterStartDate.substring(0, 2)
    );
    let end = moment(
      filterEndDate.substring(3) + "-" + filterEndDate.substring(0, 2)
    );
    start = start.subtract(1, "months");
    end = end.subtract(1, "months");

    const filterStart = start.format(dateFormat);
    const filterEnd = start.format(dateFormat);

    const filter = {
      start: filterStart,
      end: filterEnd,
      status: filterStatus,
      banks: filterBanks,
    };
    getIncome(filter)
      .then((res) => {
        const dataIncomeLast = res.mapping.filter((f) => f.mapping.length == 0);

        const receive = dataIncome.filter(
          (f) => f.name.toUpperCase().trim() == "RECEITA LÍQUIDA"
        );
        const expeneses = res.mapping.filter(
          (f) => f.name.toUpperCase().trim() == "DESPESAS OPERACIONAIS"
        );
        let total = 0;
        if (receive.length == 1) {
          total = receive[0].amountMonth.reduce((accumulator, object) => {
            return accumulator + object["profit"];
          }, 0);
        } else if (expeneses.length == 1) {
          total = expeneses[0].amountMonth.reduce((accumulator, object) => {
            return accumulator + object["profit"];
          }, 0);
        }
        dataIncome.forEach((element) => {
          dataIncomeLast.forEach((elementLast) => {
            if (element.name == elementLast.name) {
              elementLast.amount = elementLast.amountMonth.reduce(
                (accumulator, object) => {
                  return accumulator + object["profit"];
                },
                0
              );
              let percent = (elementLast.amount * 100) / total;
              element.percentLastMonth =
                formatCurrencyWithoutRS(percent.toFixed(2)) + "%";
            }
          });
        });

        setDataIncome(dataIncome);
        setLoadingIcome(false);
      })
      .catch((err) => {
        setLoadingIcome(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const refreshData = () => {
    setLoading(true);
    setPercentProfit(0);
    setProfit(0);

    getMappingData();
    getMappingDataIncome(filterStatus, filterBanks);
    //getMappingDataIncomeYear(filterStatus, filterBanks);
  };

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
    }
  };
  const setFilterEndDate = (e) => {
    if (e == null) {
      setEndDate(moment().format(dateFormat));
    } else {
      setEndDate(e.format(dateFormat));
    }
  };
  const columnsCost = [
    {
      title: "Contas",
      dataIndex: "name",
      key: "name",
      label: "Contas",
      render(text, record) {
        let margin = record.isTotal ? "0px" : "10px";
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                marginLeft: margin,
                fontWeight: fontWeight,
                cursor: "pointer",
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },

    {
      title: "Valor",
      dataIndex: "value",
      key: "value",
      label: "Valor",
      render(text, record) {
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
                cursor: "pointer",
              }}
            >
              {formatCurrency(text)}
            </div>
          ),
        };
      },
    },
    {
      title: "%",
      dataIndex: "percent",
      key: "percent",
      label: "%",
      render(text, record) {
        let fontWeight = record.isTotal ? "bold" : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text + "%"}
            </div>
          ),
        };
      },
    },
  ];
  const columns = [
    {
      title: "Grupo",
      dataIndex: "name",
      key: "name",
      label: "Grupo",
      render(text, record) {
        let fontWeight =
          record.name == "MARGEM BRUTA" ||
          record.name == "RESULTADO OPERACIONAL" ||
          record.name == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
    {
      title: "Valor",
      dataIndex: "amount",
      key: "amount",
      label: "Despesa",

      render(text, record) {
        let fontWeight =
          record.name == "MARGEM BRUTA" ||
          record.name == "RESULTADO OPERACIONAL" ||
          record.name == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";

        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {formatCurrency(text)}
            </div>
          ),
        };
      },
    },
    {
      title: "% Mês Atual",
      dataIndex: "percent",
      key: "percent",
      label: "% Mês Atual",
      render(text, record) {
        let fontWeight =
          record.name == "MARGEM BRUTA" ||
          record.name == "RESULTADO OPERACIONAL" ||
          record.name == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";
        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
    {
      title: "% Mês Anterior",
      dataIndex: "percentLastMonth",
      key: "percentLastMonth",
      label: "% Mês Anterior",
      render(text, record) {
        let fontWeight =
          record.name == "MARGEM BRUTA" ||
          record.name == "RESULTADO OPERACIONAL" ||
          record.name == "RESULTADO LÍQUIDO"
            ? "bold"
            : "initial";
        return {
          children: (
            <div
              style={{
                fontWeight: fontWeight,
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
  ];

  const columnsBalance = [
    {
      title: "Mês",
      dataIndex: "monthDate",
      key: "monthDate",
      label: "Mês",
    },
    {
      title: "Receita",
      dataIndex: "revenue",
      key: "revenue",
      label: "Receita",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Despesa",
      dataIndex: "expense",
      key: "expense",
      label: "Despesa",
      render: (text) => {
        return formatCurrency(text);
      },
    },
    {
      title: "Ponto de equilíbrio",
      label: "Ponto de equilíbrio",
      dataIndex: "balance",
      key: "balance",
      render: (text) => {
        return formatCurrency(text);
      },
    },
  ];

  let dataMargin = margin;

  let colorMargin = "#2A8DEB";
  let prefixMargin = "";
  if (dataMargin < 0) {
    dataMargin = dataMargin * -1;
    prefixMargin = "-";
    colorMargin = "#ED5E80";
  }
  let revenuePercent = data.budgetRevenuePercent;
  if (revenuePercent > 100) {
    revenuePercent = 100;
  }

  let expensePercent = data.budgetExpensePercent;
  if (expensePercent > 100) {
    expensePercent = 100;
  }

  function showConfirm(title, div) {
    info({
      title: <div style={{ textAlign: "center" }}>{title}</div>,
      icon: null,
      content: div,
      width: "90%",
      centered: true,
      getContainer() {},
      onOk() {},
    });
  }

  function showAllCashFlowLate(data) {
    info({
      title: <div style={{ textAlign: "center" }}>Inadimplentes</div>,
      icon: null,
      content: (
        <div style={{ textAlign: "center" }}>
          <Table
            columns={ColumnsCashFlowLate}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </div>
      ),
      width: "50%",
      centered: true,
      onOk() {},
    });
  }
  return (
    <div>
      <Row style={{ padding: "10px" }}>
        <Form layout={"inline"}>
          <Form.Item name="startDate" label="Mês Inicial">
            <DatePicker
              defaultValue={dayjs(filterStartDate, dateFormat)}
              format={dateFormat}
              picker="month"
              allowClear={false}
              placeholder="Selecione o mês inicial"
              onChange={setFilterStartDate}
            />
          </Form.Item>
          <Form.Item name="endDate" label="Mês Final">
            <DatePicker
              defaultValue={dayjs(filterEndDate, dateFormat)}
              format={dateFormat}
              picker="month"
              allowClear={false}
              placeholder="Selecione o mês final"
              onChange={setFilterEndDate}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" onClick={refreshData}>
              Filtrar
            </Button>
          </Form.Item>
        </Form>
      </Row>
      <div style={{ background: "#ECECEC" }}>
        <Spin size="large" spinning={loading}>
          <Row gutter={[16, 16]} style={{ maxHeight: "150px" }}>
            <Col span={5}>
              <div className="container-card">
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px", padding: "0px" }}
                >
                  <Statistic
                    title="Total Receita"
                    value={formatCurrencyWithoutRS(data.revenue)}
                    precision={2}
                  />
                </Card>
              </div>
            </Col>
            <Col span={5}>
              <div className="container-card">
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="Total Despesa"
                    value={formatCurrencyWithoutRS(data.expense)}
                    precision={2}
                  />
                </Card>
              </div>
            </Col>
            <Col span={4}>
              <div>
                <div
                  className="card-default"
                  style={{ minHeight: "300px", textAlign: "center" }}
                >
                  <div style={{ padding: "10px" }}>% Margem Bruta</div>
                  <Progress
                    className="progress-margin"
                    type="circle"
                    percent={dataMargin}
                    format={(percent) =>
                      `${prefixMargin} ${dataMargin.toFixed(2)}%`
                    }
                    strokeColor={colorMargin}
                    style={{ marginTop: "15%", marginLeft: "-6px" }}
                  />
                </div>
              </div>
            </Col>
            <Col span={5}>
              <div className="container-card">
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="Contas a Receber"
                    value={formatCurrencyWithoutRS(data.billReceive)}
                    precision={2}
                  />
                  <div
                    style={{
                      fontSize: "10px",
                      marginTop: "80px",
                      fontWeight: "bold",
                    }}
                  >
                    Prazo médio de recebimento:{" "}
                    {formatCurrencyWithoutRS(data.averageReceive)} dias
                  </div>
                </Card>
              </div>
            </Col>
            <Col span={5}>
              <div className="container-card">
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="Contas a Pagar"
                    value={formatCurrencyWithoutRS(data.billPaid)}
                    precision={2}
                  />
                  <div
                    style={{
                      fontSize: "10px",
                      marginTop: "80px",
                      fontWeight: "bold",
                    }}
                  >
                    Prazo médio de pagamento:{" "}
                    {formatCurrencyWithoutRS(data.averagePaidDaly)} dias
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={5}>
              <div className="container-card" style={{ paddingRight: "18px" }}>
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="Lucro Operacional"
                    value={formatCurrencyWithoutRS(profit)}
                    precision={2}
                  />
                </Card>
              </div>
            </Col>
            <Col span={5}>
              <div className="container-card" style={{ paddingRight: "15px" }}>
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="% Lucro Operacional"
                    value={formatCurrencyWithoutRS(percentProfit)}
                    valueStyle={{ color: "#2A8DEB" }}
                    precision={2}
                    suffix="%"
                  />
                  <div
                    style={{
                      fontSize: "10px",
                      marginTop: "80px",
                      fontWeight: "bold",
                    }}
                  >
                    Lucro operacional / Receita bruta
                  </div>
                </Card>
              </div>
            </Col>
            <Col span={5} offset={4}>
              <div className="container-card" style={{ paddingLeft: "15px" }}>
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px" }}
                >
                  <Statistic
                    title="Saldo no mês"
                    value={formatCurrencyWithoutRS(data.amountMonth)}
                    precision={2}
                  />
                </Card>
              </div>
            </Col>
            <Col span={5}>
              <div className="container-card" style={{ paddingLeft: "15px" }}>
                <Card
                  className="card-default"
                  bordered={false}
                  style={{ minHeight: "135px", cursor: data.billReceiveLast ==  0? "none": "pointer" }}
                  onClick={
                    data.billReceiveLast ==  0
                      ? () => {}
                      : () => showAllCashFlowLate(data.listLateReceive)
                  }
                >
                  <Statistic
                    title="Inadimplentes"
                    value={formatCurrencyWithoutRS(data.billReceiveLate)}
                    precision={2}
                  />
                </Card>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Spin spinning={loadingKpi}>
                <div className="container-card">
                  <div
                    className="card-default"
                    style={{ minHeight: "340px", maxHeight: "340px" }}
                  >
                    <Space>
                      <div>Receita e Despesa</div>
                      <Button
                        type="link"
                        onClick={() =>
                          showConfirm(
                            "Receita e Despesa",
                            <ReactFusioncharts
                              type="msstackedcolumn2dlinedy"
                              width="95%"
                              height="300%"
                              dataFormat="JSON"
                              dataSource={mountChartProfitBar(
                                kpiReveueAndExpense,
                                "Receita e Despesa"
                              )}
                            />
                          )
                        }
                      >
                        Expandir
                      </Button>
                    </Space>

                    <ReactFusioncharts
                      type="msstackedcolumn2dlinedy"
                      width="95%"
                      height="80%"
                      dataFormat="JSON"
                      dataSource={mountChartProfitBar(
                        kpiReveueAndExpense,
                        "Receita e Despesa"
                      )}
                    />
                  </div>
                </div>
              </Spin>
            </Col>
            <Col span={6}>
              <div className="container-card">
                <div
                  className="card-default"
                  style={{ minHeight: "340px", maxHeight: "340px" }}
                >
                  {data.showBuget && (
                    <div style={{ padding: "10px" }}>
                      % Orçamento da receita
                    </div>
                  )}
                  {!data.showBuget && (
                    <div style={{ padding: "10px" }}>
                      % Receita mês anterior
                    </div>
                  )}
                  <Progress
                    type="circle"
                    className="revenue"
                    percent={
                      data.showBuget ? revenuePercent : data.revenuePercentLast
                    }
                    format={(percent) =>
                      `${
                        data.showBuget
                          ? data.budgetRevenuePercent
                            ? data.budgetRevenuePercent
                            : 0
                          : data.revenuePercentLast
                      }%`
                    }
                    strokeColor="#2A8DEB"
                    style={{ marginTop: "15%" }}
                  />
                  <div
                    style={{
                      textAlign: "initial",
                      padding: "10px",

                      marginTop: "30px",
                    }}
                  >
                    {data.showBuget && (
                      <div>Orçado: {formatCurrency(data.budgetRevenue)}</div>
                    )}
                    {!data.showBuget && (
                      <div>
                        Mês anterior: {formatCurrency(data.billReceiveLast)}
                      </div>
                    )}
                    <div style={{ fontWeight: "bold" }}>
                      Realizado: {formatCurrency(data.revenue)}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={6}>
              <div className="container-card">
                <div
                  className="card-default"
                  style={{ minHeight: "340px", maxHeight: "340px" }}
                >
                  {data.showBuget && (
                    <div style={{ padding: "10px" }}>
                      % Orçamento da despesa
                    </div>
                  )}
                  {!data.showBuget && (
                    <div style={{ padding: "10px" }}>
                      % Despesa mês anterior
                    </div>
                  )}
                  <Progress
                    type="circle"
                    percent={
                      data.showBuget ? expensePercent : data.paidPercentLast
                    }
                    format={(percent) =>
                      `${
                        data.showBuget
                          ? data.budgetExpensePercent
                            ? data.budgetExpensePercent
                            : 0
                          : data.paidPercentLast
                      }%`
                    }
                    strokeColor="#ED5E80"
                    style={{ marginTop: "15%" }}
                  />
                  <div
                    style={{
                      textAlign: "initial",
                      padding: "10px",
                      marginTop: "30px",
                    }}
                  >
                    {data.showBuget && (
                      <div>Orçado: {formatCurrency(data.budgetExpense)}</div>
                    )}
                    {!data.showBuget && (
                      <div>
                        Mês anterior: {formatCurrency(data.billPaidLast)}
                      </div>
                    )}
                    <div style={{ fontWeight: "bold" }}>
                      Realizado: {formatCurrency(data.expense)}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: " 25px;" }}>
            <Col span={24}>
              <div className="container-card">
                <div className="card-default" style={{ minHeight: "400px" }}>
                  <Space>
                    <div>Saldo no final do mês</div>
                    <Button
                      type="link"
                      onClick={() =>
                        showConfirm(
                          "Saldo no final do mês",
                          <ReactFusioncharts
                            type="line"
                            width="95%"
                            height="300%"
                            dataFormat="JSON"
                            dataSource={mountChartLine(
                              kpiAmountFinal,
                              "Saldo no final do mês"
                            )}
                          />
                        )
                      }
                    >
                      Expandir
                    </Button>
                  </Space>
                  <ReactFusioncharts
                    type="line"
                    width="95%"
                    height="80%"
                    dataFormat="JSON"
                    dataSource={mountChartLine(
                      kpiAmountFinal,
                      "Saldo o final do mês"
                    )}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: " 25px;" }}>
            <Col span={12}>
              <Spin spinning={loadingIncome}>
                <div className="container-card">
                  <div className="card-default" style={{ minHeight: "340px" }}>
                    <Space>
                      <div>Demonstrativo de resultados</div>
                      <Button
                        type="link"
                        onClick={() =>
                          showConfirm(
                            "Demonstrativo de resultados",
                            <ReactFusioncharts
                              type="waterfall2d"
                              width="95%"
                              height="300%"
                              dataFormat="JSON"
                              dataSource={mountWaterFall(
                                dataIncome,
                                "Demonstrativo de resultados"
                              )}
                            />
                          )
                        }
                      >
                        Expandir
                      </Button>
                    </Space>
                    <ReactFusioncharts
                      type="waterfall2d"
                      width="95%"
                      height="80%"
                      dataFormat="JSON"
                      dataSource={mountWaterFall(
                        dataIncome,
                        "Demonstrativo de resultados"
                      )}
                    />
                  </div>
                </div>
              </Spin>
            </Col>
            <Col span={12}>
              <div className="container-card">
                <div
                  className="card-default"
                  style={{
                    minHeight: "340px",
                    maxHeight: "340px",
                    overflow: "auto",
                  }}
                >
                  <Table
                    size="small"
                    loading={loadingIncome}
                    columns={columns}
                    pagination={false}
                    dataSource={dataIncome}
                    title={() => (
                      <Space>
                        <div>Demonstrativo de resultados</div>
                        <Button
                          type="link"
                          onClick={() =>
                            showConfirm(
                              "Demonstrativo de resultados",
                              <Table
                                size="small"
                                loading={loadingIncome}
                                columns={columns}
                                pagination={false}
                                dataSource={dataIncome}
                                title={() => "Demonstrativo de resultados"}
                              />
                            )
                          }
                        >
                          Expandir
                        </Button>
                        <CSVLink
                          filename={"Demonstrativo de resultados.csv"}
                          data={dataIncome}
                          headers={columns}
                        >
                          Baixar
                        </CSVLink>
                      </Space>
                    )}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <div className="container-card">
                <div
                  className="card-default"
                  style={{
                    minHeight: "340px",
                    maxHeight: "340px",
                    overflow: "auto",
                  }}
                >
                  <Table
                    size="small"
                    pagination={false}
                    columns={columnsCost}
                    dataSource={dataCost}
                    onRow={(record, rowIndex) => {
                      return {
                        onClick: (event) => {
                          let list = [];

                          data.costKpi.forEach((item) => {
                            let showChildren = dataCost
                              .filter((key) => key.name == item.name)
                              .map((obj) => obj.showChildren)[0];
                            if (item.name == record.name) {
                              showChildren = !record.showChildren;
                            }

                            list.push({
                              ...item,
                              showChildren: showChildren,
                            });
                            if (showChildren && item.values) {
                              item.values.forEach((children) => {
                                list.push({
                                  ...children,
                                });
                              });
                            }
                          });
                          setDataCost(list);
                        }, // click row
                      };
                    }}
                    title={() => (
                      <Space>
                        <div>Custo Fixo e Variável</div>
                        <Button
                          type="link"
                          onClick={() =>
                            showConfirm(
                              "Custo Fixo e Variável",
                              <Table
                                size="small"
                                columns={columnsCost}
                                pagination={false}
                                dataSource={data.costKpiAll}
                              />
                            )
                          }
                        >
                          Expandir
                        </Button>
                        <CSVLink
                          filename={"Custo Fixo e Variável.csv"}
                          data={data.costKpiAll}
                          headers={columnsCost}
                        >
                          Baixar
                        </CSVLink>
                      </Space>
                    )}
                  />
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className="container-card">
                <div className="card-default" style={{ minHeight: "340px" }}>
                  <Space>
                    <div>Custo Fixo e Variável</div>
                    <Button
                      type="link"
                      onClick={() =>
                        showConfirm(
                          "Custo Fixo e Variável",
                          <ReactFusioncharts
                            type="doughnut2d"
                            width="95%"
                            height="300%"
                            dataFormat="JSON"
                            dataSource={mountChartPie(
                              data.costKpiChart,
                              "Custo Fixo e Variável",
                              "#ffffff",
                              "#2A8DEB"
                            )}
                          />
                        )
                      }
                    >
                      Expandir
                    </Button>
                  </Space>
                  <ReactFusioncharts
                    type="doughnut2d"
                    width="95%"
                    height="75%"
                    dataFormat="JSON"
                    dataSource={mountChartPie(
                      data.costKpiChart,
                      "Custo Fixo e Variável",
                      "#ffffff",
                      "#2A8DEB"
                    )}
                  />
                </div>
              </div>
            </Col>
          </Row>
          {/*
            <Row gutter={[16, 16]} style={{ marginTop: " 25px;" }}>
              <Col span={12}>
                <div className="container-card">
                  <div className="card-default" style={{ minHeight: "340px" }}>
                    <Space>
                      <div>Ponto de equilíbrio</div>
                      <Button
                        type="link"
                        onClick={() =>
                          showConfirm(
                            "Ponto de equilíbrio",
                            <ReactFusioncharts
                              type="msline"
                              width="92%"
                              height="300%"
                              dataFormat="JSON"
                              dataSource={mountChartMultLine(
                                data.cashFlowYear,
                                "Ponto de equilíbrio",
                                data.averagePaid
                              )}
                            />
                          )
                        }
                      >
                        Expandir
                      </Button>
                    </Space>
                    <ReactFusioncharts
                      type="msline"
                      width="92%"
                      height="85%"
                      dataFormat="JSON"
                      dataSource={mountChartMultLine(
                        data.cashFlowYear,
                        "Ponto de equilíbrio",
                        data.averagePaid
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="container-card">
                  <div
                    className="card-default"
                    style={{
                      minHeight: "340px",
                      maxHeight: "340px",
                      overflow: "auto",
                    }}
                  >
                    <Table
                      size="small"
                      columns={columnsBalance}
                      pagination={false}
                      dataSource={data.cashFlowYear}
                      title={() => (
                        <Space>
                          <div>Ponto de equilíbrio</div>
                          <Button
                            type="link"
                            onClick={() =>
                              showConfirm(
                                "Ponto de equilíbrio",
                                <Table
                                  size="small"
                                  columns={columnsBalance}
                                  pagination={false}
                                  dataSource={data.cashFlowYear}
                                />
                              )
                            }
                          >
                            Expandir
                          </Button>
                          <CSVLink
                            filename={"Ponto de equilíbrio.csv"}
                            data={data.cashFlowYear}
                            headers={columnsBalance}
                          >
                            Baixar
                          </CSVLink>
                        </Space>
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>
                          */}
        </Spin>
      </div>
    </div>
  );
};
export default KpiCashFlow;
